(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-centered-newsletter"] && !Shopify.designMode) return;
  try {
    
(function() {
  const section = document.currentScript.closest('[data-section-type="centered-newsletter"]');
  if (!section) return;

  if (window.theme && window.theme.initAnimateOnScroll) {
    window.theme.initAnimateOnScroll(section);
  }
})();


// 

document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 767) {
    const benefits = document.querySelector("#CenteredNewsletter--{{ section.id }} .centered-newsletter__benefits");
    if (benefits) {
      new Flickity(benefits, {
        cellAlign: "center",
        contain: true,
        prevNextButtons: false,
        wrapAround: true,
        autoPlay: 100, // auto slide every 2.5s
        // pauseAutoPlayOnHover: true,
        pageDots: true,
        draggable: true,
      });
    }
  }
});







  } catch(e) { console.error(e); }
})();
})();
